/**! Qoopido.demand 5.0.2 | https://github.com/dlueth/qoopido.demand | (c) 2018 Dirk Lueth */
(function (localStorage) {
	"use strict";

	function definition(functionIterate) {
		function getState(key) {
			var matches, state = localStorage.getItem(key);
			if (state && (matches = state.match(regexMatchProperties))) return Array.prototype.slice.call(matches, 1)
		}

		function getKey(id) {
			return "[" + PREFIX + "][" + id + "][" + SUFFIX + "]"
		}

		function filterStates(property) {
			var state, match = property.match(regexMatchState);
			if (match) {
				(state = getState(getKey(match[1])))[5] = match[1];
				this.push(state)
			}
		}

		function compareAccess(a, b) {
			if (a[4] < b[4]) return -1;
			if (a[4] > b[4]) return 1;
			else return 0
		}
		var PREFIX = "demand",
			SUFFIX = "state",
			regexMatchState = new RegExp("^\\[" + PREFIX + "\\]\\[(.+?)\\]\\[" + SUFFIX + "\\]$"),
			regexMatchProperties = /^(.+?),(\d+),(\d*),(.+?),(\d+)$/;
		functionIterate(localStorage, function (property) {
			var match = property.match(regexMatchState);
			if (match)
				if (!getState(getKey(match[1]))[4]) demand.clear.path(match[1])
		});
		return function (size) {
			var state, states = [];
			functionIterate(localStorage, filterStates, states);
			states.sort(compareAccess);
			while (size > 0 && states.length) {
				size -= (state = states.shift())[1];
				demand.clear.path(state[5])
			}
		}
	}
	provide(["/demand/function/iterate"], definition)
})(localStorage);
